import { FullScreenSpinner } from "~/v2/components/common";
import { usePlaidOAuthReturnController } from "./PlaidOAuthReturn.controller";
import { PlaidOAuthReturnPresentation } from "./PlaidOAuthReturn.pres";

export const PlaidOAuthReturn = () => {
  const {
    status,
    isPlaidReady,
    isVerifyingMicroDeposit,
    onOpenPlaid,
    onBack,
    isResolving,
    isUnavailable,
  } = usePlaidOAuthReturnController();

  // Spinner while the account loads / the session resolves, and while an
  // unresumable (orphan) return is being redirected to the fresh page.
  if (isResolving || isUnavailable) {
    return <FullScreenSpinner />;
  }

  return (
    <PlaidOAuthReturnPresentation
      status={status}
      isPlaidReady={isPlaidReady}
      isVerifyingMicroDeposit={isVerifyingMicroDeposit}
      onOpenPlaid={onOpenPlaid}
      onBack={onBack}
    />
  );
};

export default PlaidOAuthReturn;
